import { render, staticRenderFns } from "./move-multiple-videos.vue?vue&type=template&id=45406fa2&scoped=true&"
import script from "./move-multiple-videos.vue?vue&type=script&lang=js&"
export * from "./move-multiple-videos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45406fa2",
  null
  
)

export default component.exports